import React from 'react';
import { Select } from 'antd';
import { useCountry } from '../../context/CountryContext';

/** Renders a flag using flagcdn.com — works on all OSes including Windows Chrome */
const FlagImg: React.FC<{ code: string }> = ({ code }) => {
  const lower = code.toLowerCase();
  return (
    <img
      src={`https://flagcdn.com/w20/${lower}.png`}
      srcSet={`https://flagcdn.com/w40/${lower}.png 2x`}
      width={20}
      height={14}
      alt={code}
      style={{ objectFit: 'cover', borderRadius: 2, verticalAlign: 'middle', flexShrink: 0 }}
      onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
    />
  );
};

interface Props {
  /** Transparent header mode (home hero). Adjusts colours. */
  transparent?: boolean;
  size?: 'small' | 'middle';
}

const CountrySelector: React.FC<Props> = ({ transparent = false, size = 'small' }) => {
  const { selectedCountry, setSelectedCountry, allCountries } = useCountry();

  const handleChange = (id: string) => {
    const country = allCountries.find((c) => c.id === id);
    if (country) setSelectedCountry(country);
  };

  return (
    <Select
      size={size}
      value={selectedCountry?.id}
      onChange={handleChange}
      loading={allCountries.length === 0}
      variant="borderless"
      popupMatchSelectWidth={false}
      style={{
        minWidth: 118,
        fontWeight: 600,
        fontSize: 13,
        background: transparent ? 'rgba(255,255,255,0.14)' : '#f1f5f9',
        borderRadius: 8,
      }}
      options={allCountries.map((c) => ({
        value: c.id,
        label: (
          <span style={{ display: 'flex', alignItems: 'center', gap: 6, fontWeight: 600 }}>
            <FlagImg code={c.code} />
            <span style={{ color: transparent ? 'rgba(255,255,255,0.92)' : '#1e293b' }}>
              {c.name}
            </span>
          </span>
        ),
      }))}
    />
  );
};

export default CountrySelector;
